module.exports = __webpack_public_path__ + "img/DS1522+.2bd9e1db.png";